// extracted by css-extract-rspack-plugin
export default {"bar":"_35c61a57","stickyBar":"_7351e528","barContent":"_3d0d9d5e","isFullWidth":"_e244d449","rightContainer":"_2e35ec41","basis261":"_f4a92e79"};